import { combineReducers } from 'redux'
import { reducers } from '@/contexts'

export default combineReducers(reducers)
